/**
 * Criterio de búsqueda de propiedades.
 *
 * Espejo tipado de `PropertyFilterRequestDto` (backend Quarkus
 * `POST /api/property/search`). La paginación (`offset` / `pageSize`)
 * viaja como query params, no en el body — ver {@link SearchPageRequest}.
 */
export interface SearchCriteria {
    defaultPage?: boolean;
    segmentId?: number | null;
    adId?: number | null;
    cityId?: number | null;
    zoneId?: number | null;
    /** Precio mínimo (string, como lo espera el backend). */
    amount1?: string | null;
    /** Precio máximo. */
    amount2?: string | null;
    /** Superficie mínima. */
    surface1?: string | null;
    /** Superficie máxima. */
    surface2?: string | null;
    /** Códigos de características seleccionadas (ValueDto.featureCode / DataFeatureResponseDto.featureCode). */
    featureFilters?: string[];
    orderOptions?: SortOption | null;
}

/**
 * Valores aceptados por el ORDER BY del backend
 * (ver `PropertyDao.java`: switch sobre `orderOptions`).
 */
export type SortOption = 'last_first' | 'price_min' | 'price_max';

/** Paginación enviada como query params al endpoint de búsqueda. */
export interface SearchPageRequest {
    offset: number;
    pageSize: number;
}

export const DEFAULT_PAGE_SIZE = 10;
